module.exports = __webpack_public_path__ + "img/share_bg_03.599a9574.png";